export default __webpack_public_path__ + "static/media/ID7495.69d683a2.png";